import { connect } from 'react-redux';
import SuspicionDashboard from './SuspicionDashboard';
import { getSuspicionDashboard, getSuspicionMembers } from './suspicionDashboardActions';
import { getOfficesShortList } from '../Offices/officesActions';

const mapStateToProps = state => ({
    isLoading: state.suspicionDashboard.isLoading,
    dashboardData: state.suspicionDashboard.dashboardData,
    membersLoading: state.suspicionDashboard.membersLoading,
    membersList: state.suspicionDashboard.membersList,
    officesShortList: state.office.officesShortList,
});

const mapDispatchToProps = dispatch => ({
    getSuspicionDashboard: params => dispatch(getSuspicionDashboard(params)),
    getSuspicionMembers: params => dispatch(getSuspicionMembers(params)),
    getOfficesShortList: () => dispatch(getOfficesShortList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuspicionDashboard);
